export default "__VITE_ASSET__9a379c31__"